'use strict';

/**
 * @ngdoc directive
 * @name courseApp.directive:tab
 * @description
 * # tab
 */
angular.module('courseApp')
    .directive('tab', function () {
        return {
            restrict: 'E',
            transclude: true,
            template: '<div role="tabpanel" ng-show="active" ng-transclude></div>',
            require: '^tabset',
            scope: {
                heading: '@'
            },
            link: function (scope, elem, attr, tabsetCtrl) {
                scope.active = false;
                tabsetCtrl.addTab(scope);
            }
        };
    });
